"use strict";

exports.__esModule = true;
exports.useItemSelection = useItemSelection;
var _react = _interopRequireWildcard(require("react"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function useItemSelection(selected) {
  const [selection, setSelection] = (0, _react.useState)(selected || {});
  const onItemSelection = (0, _react.useCallback)((item, isItemsUnselectable, isPersistSelectEvent) => {
    const newId = item.id;

    // creates new selection obj - {id:{text:''}}
    const newSelection = {};
    if (!selection[newId]) {
      newSelection[newId] = {
        text: item.text
      };
    }
    if (newSelection[newId] || selection[newId] && isItemsUnselectable || isPersistSelectEvent) {
      // New selection or unselection
      setSelection(newSelection);

      // If we want to always select the item
      if (isPersistSelectEvent) return item;

      // When unselected event occurs return empty {} else item
      return selection[newId] ? {} : item;
    }
    return undefined;
  }, [selection, setSelection]);
  return {
    selection,
    setSelection,
    onItemSelection
  };
}